import { defineComponent } from "vue"

export default defineComponent({
  emits: ["click"] as const,
  props: ["name", "title"] as const,
  render() {
    return (
      <i
        class={`icon icon-${this.name}`}
        title={this.title}
        onClick={(e: Event) => this.$emit("click", e)}
      />
    )
  },
})
